import React from 'react';

type BadgeVariant = 'default' | 'muted' | 'selected';
type BadgeSize = 'sm' | 'md';
type BadgeElement = 'span' | 'div' | 'button';

interface BadgeProps extends React.HTMLAttributes<HTMLElement> {
  as?: BadgeElement;
  variant?: BadgeVariant;
  size?: BadgeSize;
  children: React.ReactNode;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-input/70 border-border/80 text-foreground',
  muted: 'bg-muted/70 border-border/70 text-muted-foreground',
  selected: 'bg-secondary-foreground border-secondary-foreground text-primary-foreground',
};

const sizeClasses: Record<BadgeSize, string> = {
  sm: 'px-2.5 py-1 text-xs',
  md: 'px-3 py-1.5 text-sm',
};

function Badge({
  as = 'span',
  variant = 'default',
  size = 'sm',
  className = '',
  children,
  ...props
}: BadgeProps) {
  const Element = as as React.ElementType;
  const elementProps = as === 'button' ? { type: 'button', ...props } : props;
  const interactiveClass = as === 'button' ? 'cursor-pointer' : '';

  return (
    <Element
      className={`inline-flex items-center justify-center rounded-full border font-semibold leading-none ${variantClasses[variant]} ${sizeClasses[size]} ${interactiveClass} ${className}`}
      {...elementProps}
    >
      {children}
    </Element>
  );
}

export default Badge;
